import type { ReactNode } from 'react';

import { Modal } from '../modal';
import { OverlayPattern } from '../overlay';

import styles from './result-dialog.module.scss';

export type ResultDialogProps = {
  open: boolean;
  /** Illustration icon source (success / warning / feedback webp). */
  icon: string;
  title: string;
  subtitle: string;
  /** Footer actions (e.g. feedback buttons). Omitted → close-only dialog. */
  actions?: ReactNode;
  onClose: () => void;
};

/**
 * Centered outcome dialog used by the support + warranty flows: a faint header pattern
 * behind a 76px illustration, title, subtitle, and optional footer actions. Close-only
 * (just the ✕) unless `actions` are supplied. Figma: success / warning / feedback variants.
 */
export function ResultDialog({ open, icon, title, subtitle, actions, onClose }: ResultDialogProps) {
  return (
    <Modal open={open} onClose={onClose} size="sm" hideFooter>
      <div className={styles.layout}>
        <OverlayPattern className={styles.pattern} />
        <img src={icon} alt="" className={styles.icon} />
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </Modal>
  );
}
